import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'emotional_state'

export default function EmotionalStatePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How do you usually feel when you wake up from dreams?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.emotionalState.heading')}
      buttons={[
        {
          text: `😊 ${t('pages.onboarding.emotionalState.options.calm')}`,
          value: 'Calm and peaceful',
          subtext: t('pages.onboarding.emotionalState.subtexts.calm'),
        },
        {
          text: `🤔 ${t('pages.onboarding.emotionalState.options.curious')}`,
          value: 'Curious and intrigued',
          subtext: t('pages.onboarding.emotionalState.subtexts.curious'),
        },
        {
          text: `😰 ${t('pages.onboarding.emotionalState.options.anxious')}`,
          value: 'Sometimes anxious or unsettled',
          subtext: t('pages.onboarding.emotionalState.subtexts.anxious'),
        },
        {
          text: `😢 ${t('pages.onboarding.emotionalState.options.emotional')}`,
          value: 'Deeply emotional',
          subtext: t('pages.onboarding.emotionalState.subtexts.emotional'),
        },
        {
          text: `😐 ${t('pages.onboarding.emotionalState.options.neutral')}`,
          value: 'Neutral - dreams dont affect me much',
          subtext: t('pages.onboarding.emotionalState.subtexts.neutral'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
